export const OptimizersFormPageSubjects = {
    Page: 'optimizers-form-page',
    NameField: 'optimizers-form-name-field',
    DescriptionField: 'optimizers-form-description-field',
    QueryField: 'optimizers-form-query-field',
    SaveButton: 'optimizers-form-save-button',
    CancelButton: 'optimizers-form-cancel-button',
};
//# sourceMappingURL=optimizers-form.enum.js.map